import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { InventoryCategoryComponent } from './inventory-category/inventory-category.component';
import { InventoryItemCategoryComponent } from './inventory-item-category/inventory-item-category.component';
import { InventoryItemComponent } from './inventory-item/inventory-item.component';
import { UOMComponent } from './uom/uom.component';
import { StockInformationComponent } from './stock-information/stock-information.component';
import { PurchaseOrderComponent } from './purchase-order/purchase-order.component';
import { PrintPurchaseOrderComponent } from './print-purchase-order/print-purchase-order.component';
import { PurchaseOrderReceivingComponent } from './purchase-order-receiving/purchase-order-receiving.component';
import { PurchaseOrderApprovalComponent } from './purchase-order-approval/purchase-order-approval.component';
import { PrintPOApprovalComponent } from './print-poapproval/print-poapproval.component';
import { PurchaseInvoiceComponent } from './purchase-invoice/purchase-invoice.component';
import { GeneralInvoicePaymentComponent } from './general-invoice-payment/general-invoice-payment.component';
import { VendorDueReportComponent } from './vendor-due-report/vendor-due-report.component';
import { PurchasePaymentComponent } from './purchase-payment/purchase-payment.component';
import { StockStatementComponent } from './stock-statement/stock-statement.component';
import { StockAdjustmentComponent } from './stock-adjustment/stock-adjustment.component';
import { StockAdjustmentPrintComponent } from './stock-adjustment-print/stock-adjustment-print.component';


const routes: Routes = [{ 
  path: '', 
  component: AdminComponent,
  children: [
    { path: 'invinventorycategory', component:InventoryCategoryComponent, pathMatch: 'full'},
   { path: 'invinventoryitemcategory', component:InventoryItemCategoryComponent, pathMatch: 'full'}, 
   { path: 'invinventoryitem', component:InventoryItemComponent, pathMatch: 'full'},     
     { path: 'invuom', component:UOMComponent, pathMatch: 'full'},
     { path: 'invstockinformation', component:StockInformationComponent, pathMatch: 'full'},
    { path: 'invpurchaseorder', component:PurchaseOrderComponent, pathMatch: 'full'},
    { path: 'invpurchaseorderreceiving', component:PurchaseOrderReceivingComponent, pathMatch: 'full'},
    { path: 'invpurchaseorderapproval', component:PurchaseOrderApprovalComponent, pathMatch: 'full'},
    { path: 'invpurchaseinvoice', component:PurchaseInvoiceComponent, pathMatch: 'full'},
    { path: 'generalinvoicepayment', component:GeneralInvoicePaymentComponent, pathMatch: 'full'},
    { path: 'vendorduereport', component:VendorDueReportComponent, pathMatch: 'full'},
    { path: 'invpayment', component:PurchasePaymentComponent, pathMatch: 'full'},
    { path: 'stockstatement', component:StockStatementComponent, pathMatch: 'full'},
    { path: 'stkstockadjustment', component:StockAdjustmentComponent, pathMatch: 'full'}
    
  ]
},
{ 
  path: '',   
  children: [
    { path: 'printpurchaseorder', component:PrintPurchaseOrderComponent, pathMatch: 'full'},
    { path: 'printpoapproval', component:PrintPOApprovalComponent, pathMatch: 'full'},
    { path: 'stockadjustmentprint', component: StockAdjustmentPrintComponent, pathMatch: 'full' },
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PurchaseRoutingModule { }
